<!-- Mobile -->
<div class="ion-hide-sm-up">
  <div class="ion-text-center">
    <ion-button *ngIf="showDeleteButton" fill="clear" size="small" (click)="deleteButtonEvent.emit()">
      {{'COMPONENTS.DELETE' | translate}}
    </ion-button>
    <ion-button *ngIf="showSortButton" fill="clear" size="small" (click)="sortButtonEvent.emit()">{{'COMPONENTS.ORDER' |
      translate}}</ion-button>
  </div>

  <div class="reload-button">
    <ion-button *ngIf="showReloadButton" fill="clear" size="large"
      (click)="reloadButtonEvent.emit()">
      <ion-icon name="reload-outline"></ion-icon>
    </ion-button>
  </div>


  <h1 regular class="ion-padding-horizontal text-primary-dark ion-text-center ion-text-uppercase">
    {{ title }}
    <ion-icon *ngIf="renamable" color="primary" name="pencil-outline" (click)="renameButtonEvent.emit()"></ion-icon>
  </h1>
  <h4 light class="ion-padding-horizontal text-primary-dark ion-text-center">
    {{ subtitle }}
  </h4>
</div>

<!-- Web -->
<div class="ion-hide-sm-down ion-padding-horizontal ion-margin-vertical">
  <div flex class="ion-justify-content-between">
    <div>
      <div flex class="ion-align-items-center">
        <ion-icon color="primary" src="assets/svg/caret-forward.svg"></ion-icon>
        <h1 regular class="ion-no-margin text-primary-dark ion-text-start ion-text-uppercase">
          {{ title }}
          <ion-icon *ngIf="renamable" color="primary" name="pencil-outline"
            (click)="renameButtonEvent.emit()"></ion-icon>
        </h1>
      </div>
      <h4 light margin-top-small class="ion-padding-horizontal ion-margin-bottom text-primary-dark ion-text-start">
        {{ subtitle }}
        <span *ngIf="boldText">
          <b>{{ boldText }}</b>
        </span>
      </h4>
    </div>

    <ion-button *ngIf="showDeleteButton" fill="clear" size="small"
      (click)="deleteButtonEvent.emit()">{{'COMPONENTS.DELETE' | translate}}
    </ion-button>
    <ion-button *ngIf="showSortButton" fill="clear" size="small" (click)="sortButtonEvent.emit()">{{'COMPONENTS.ORDER' |
      translate}}
    </ion-button>
    <ion-button *ngIf="showReloadButton" fill="clear" size="small"
      (click)="reloadButtonEvent.emit()">{{'COMPONENTS.RELOAD_REPORTS' | translate}}
    </ion-button>
  </div>
  <div class="divider"></div>
</div>
